import CreativeList from 'common/pages/creative/CreativeList'

export const CreativeAdvList = (props) =>
    <CreativeList {...props} agency={false} />